import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Grid,
} from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import Images from '../../../Configs/images';
import ROUTES from '../../../Configs/routes';

export default function FixedBottomNavigation({ children, classes, noNav }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [value, setValue] = useState(-1);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    switch (location.pathname) {
      case '/':
      case '/request':
      case '/home': setValue(0);
        break;
      case '/history': setValue(1);
        break;
      case '/profile': setValue(2);
        break;
      default: setValue(0);
    }
  }, [location.pathname]);

  const ref = useRef(null);
  const [parentWidth, setParentWidth] = useState(500);

  useEffect(() => {
    setParentWidth(ref.current ? ref.current.offsetWidth : 0);
    window.addEventListener('resize', () => {
      setParentWidth(ref.current ? ref.current.offsetWidth : 0);
    });
  }, [ref.current]);

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} lg={10}>
        <Box ref={ref} className={classes.root}>
          <main>
            {children}
          </main>
          {!noNav
          && (
          <Paper className="nav-container">
            <BottomNavigation
              showLabels
              sx={{ width: parentWidth }}
              className="navigation"
              value={value}
              onChange={(event, newValue) => {
                setValue(newValue);
              }}
            >
              <BottomNavigationAction onClick={() => navigate(ROUTES.request())} label="Request" icon={<img src={value === 0 ? Images.RequestActive : Images.Request} alt="Box" height="24" />} />
              <BottomNavigationAction onClick={() => navigate(ROUTES.history())} label="History" icon={<img src={value === 1 ? Images.HistoryActive : Images.History} alt="History" height="24" />} />
              <BottomNavigationAction onClick={() => navigate(ROUTES.profile())} label="Profile" icon={<img src={value === 2 ? Images.ProfileActive : Images.Profile} alt="Person" height="24" />} />
            </BottomNavigation>
          </Paper>
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
